import { Scenario } from '../types';

const scenarios = new Map<string, Scenario>();

export function registerScenario(scenario: Scenario): void {
  scenarios.set(scenario.id, scenario);
}

export function unregisterScenario(id: string): void {
  scenarios.delete(id);
}

export function getScenario(id: string): Scenario | undefined {
  return scenarios.get(id);
}

export function getAllScenarios(): Scenario[] {
  return Array.from(scenarios.values());
}

/**
 * Get scenarios filtered by user's active modules
 * @param activeModules - Array of module names the user has access to ('mcm', 'votez')
 */
export function getScenariosForModules(activeModules: ('mcm' | 'votez')[]): Scenario[] {
  return Array.from(scenarios.values()).filter((scenario) => {
    // Filter out scenarios that shouldn't appear in the menu
    if (scenario.showInMenu === false) return false;
    // If scenario has no module specified, show it to everyone
    if (!scenario.module) return true;
    // Otherwise, only show if user has access to that module
    return activeModules.includes(scenario.module);
  });
}
